import ObjectStorage from '../svgs/layers.svg';
import BlockStorage from '../svgs/objects.svg';
import FileSystem from '../svgs/files.svg';

export const interfaces = [
    {
        img: ObjectStorage,
        value: 'interfaces.object_storage',
        link: '#object_storage'
    },
    {
        img: BlockStorage,
        value: 'interfaces.block_storage',
        link: '#block_storage'
    },
    {
        img: FileSystem,
        value: 'interfaces.file_system',
        link: '#file_system'
    }
];
